export enum JoinOperator {
  OR = 'OR',
  AND = 'AND'
}

export class RequiredPermissions {
  permissions: string[];
  joinOperator: JoinOperator;
}
